export const INITIAL_VALUES = {
  lot: "",
  reservePrice: "",
  name: "",
  stakeholder: "",
};

export const ONLINE_INITIAL_VALUES = {
  lot: "",
  name: "",
  assetFamily: "",
  startPrice: "",
  minStep: "",
  reservePrice: "",
  customClearance: false,
  stakeholder: "",
  brand: "",
  model: "",
  country: {},
  driverSide: "",
  yearOfMake: "",
  mileage: "",
  engine: "",
  transmission: "",
  inspectionReport: "",
  description: "",
  photo: undefined as FileList | File[] | undefined,
  removedPhoto: undefined as FileList | File[] | undefined,
  video: "",
};
